import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import Iconify from 'src/components/Iconify';

const GROUP_SX = {
  backgroundColor: 'rgba(135, 200, 224, 0.12)',
  border: '1px solid rgba(135, 200, 224, 0.28)',
  borderRadius: '8px',
  p: '3px',
  gap: '3px',
  '& .MuiToggleButtonGroup-grouped': {
    border: 0,
    borderRadius: '6px !important',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.8rem',
    color: '#A9C9D6',
    px: 1.5,
    py: 0.5,
    transition: 'background-color 0.15s, color 0.15s',
    '&:hover': { backgroundColor: 'rgba(135, 200, 224, 0.14)', color: '#D7EAF2' },
    '&.Mui-selected': {
      color: '#EAF6FB',
      backgroundColor: 'rgba(135, 200, 224, 0.32)',
      '&:hover': { backgroundColor: 'rgba(135, 200, 224, 0.32)' },
    },
  },
};

const ViewByToggle = ({ value, options, onChange, label = 'View by:' }) => (
  <Stack direction="row" alignItems="center" gap={1}>
    <Typography sx={{ color: '#9CA3AF', fontSize: '0.8rem', fontWeight: 600 }}>{label}</Typography>
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      // Clicking the selected button would otherwise deselect it and leave the page with no view.
      onChange={(event, next) => (next == null ? undefined : onChange?.(next))}
      sx={GROUP_SX}>
      {options.map(option => (
        <ToggleButton key={option.value} value={option.value}>
          <Stack direction="row" alignItems="center" gap={0.75}>
            {option.icon ? <Iconify icon={option.icon} width={16} height={16} /> : null}
            {option.label}
          </Stack>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Stack>
);

export default ViewByToggle;
